import request from '@/utils/request'


export function getHistory(data) {
  return request({
    url: 'my/getHistory',
    method: 'get',
    params: data
  })
}

export function getOrder(data) {
  return request({
    url: 'my/getOrder',
    method: 'get',
    params: data
  })
}

export function cancelHistory(data) {
  return request({
    url: 'my/cancelHistory',
    method: 'post',
    data: data
  })
}

export function cancelOrder(data) {
  return request({
    url: 'my/cancelOrder',
    method: 'post',
    data: data
  })
}